module.exports = __webpack_public_path__ + "static/media/pressure.98b0913e.png";